import getGuestsByAwsFaceIds from './getGuestsByAwsFaceIds';

export default {
  getGuestsByAwsFaceIds,
}
